import { bindServices } from '@/services/api';
import { toImportExcel } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { queryEditActive } from './service';

const api = bindServices('dynamicEntityGroups');

export const initialPagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  isOpenModal: false,
  selectedItem: null,
  pagination: initialPagination,
  view: false,
  orderBy: '',
  dynamicEntityListGroups: [],
  latestFetchDynamicEntityListoGroups: null,
  showImport: false,
};

const Model = {
  namespace: 'dynamicEntityGroups',

  state: initialState,

  effects: {
    *fetchData({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'dynamicEntityGroup/paged',
          params: payload,
        });

        yield put({
          type: 'queryDynamicEntityGroups',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });

        yield put({
          type: 'saveLatestFetchDynamicEntityGroups',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *addNewDynamicEntityGroup({ payload }, { put }) {
      yield put({
        type: 'addDynamicEntityGroup',
        payload,
      });

      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewDynamicEntityGroup',
          payload,
        });
      }
    },
    *saveEditDynamicEntityGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'dynamicEntityGroup',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({ type: 'saveDynamicEntityGroup', payload: response });

        yield put({
          type: 'repeatLatestFetchDynamicEntityGroups',
        });
      } catch (error) {
        yield put({
          type: 'global/showNotificationsform',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
          },
          validationErrors: error.validationErrors,
        });
      }
    },
    *saveNewDynamicEntityGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'dynamicEntityGroup',
          data: payload.data,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveDynamicEntityGroup',
          payload: response,
        });

        yield put({
          type: 'repeatLatestFetchDynamicEntityGroups',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsform',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, view }, { call, put }) {
      try {
        yield put({
          type: 'global/modalConfirm',
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `dynamicEntityGroup/${id}`,
          method: 'delete',
        });

        yield put({
          type: 'deleteDynamicEntityGroup',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'repeatLatestFetchDynamicEntityGroups',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *repeatLatestFetchDynamicEntityGroups(__, { put, select }) {
      const latestPayload = yield select(
        (state) => state.dynamicEntityGroups.latestFetchDynamicEntityListoGroups,
      );

      yield put({ type: 'fetchData', payload: latestPayload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
    *fetchImport({ payload }, { call, put }) {
      try {
        const { file, isDeleteData } = payload;
        const res = yield call(toImportExcel, {
          route: 'dynamicEntityGroup',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        yield put({
          type: 'queryImport',
          payload: { ...res },
        });

        yield put({
          type: 'fetchData',
          payload: {
            page: 1,
            limit: 5,
          },
        });
      } catch (e) {
        /*  */
      }
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },
  },

  reducers: {
    queryDynamicEntityGroups(state, { payload }) {
      return {
        ...state,
        dynamicEntityListGroups: payload.items.map((item) => ({
          ...item,
          isActive: item.isActive ?? false,
        })),
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addDynamicEntityGroup(state, { payload }) {
      return {
        ...state,
        isOpenModal: payload.isOpenModal,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    saveDynamicEntityGroup(state, { payload }) {
      return {
        ...state,
        saveDynamicEntityGroup: payload,
        isOpenModal: false,
        selectedItem: null,
        id: null,
        orderBy: '',
      };
    },
    deleteDynamicEntityGroup(state) {
      return { ...state };
    },
    selectItem(state, { payload }) {
      const item = state.dynamicEntityListGroups.find((entity) => entity.id === payload.id);

      return {
        ...state,
        selectedItem: item,
        view: payload.view,
        id: payload.id,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    resetState() {
      return initialState;
    },
    saveLatestFetchDynamicEntityGroups(state, { payload }) {
      return {
        ...state,
        latestFetchDynamicEntityListoGroups: payload,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    editActives(state, { payload }) {
      const dynamicEntityListGroups = state.dynamicEntityListGroups.map((item) =>
        item.id === payload.id ? payload : item,
      );
      return {
        ...state,
        dynamicEntityListGroups,
      };
    },
  },
};

export default Model;
